<template>
    <div
        class="safe"
        :class="{ 'safe-complete': code.length == count, 'safe-video-ready': submitted || token, 'safe-result-showing': token }"
    >
        <div class="safe-container" v-if="isLoaded">
            <div class="safe-img" v-if="!token"></div>
            <div
                class="safe-display"
                :class="{ 'display-active': code.length && !(agreeTerms && !videoLoaded) && !videoPlaying, topmost: !videoPlaying }"
                @touchstart="focusAndOpenKeyboard"
                v-if="!token"
            >
                <div class="safe-code" v-for="n in count" :key="n" :class="classCode(n)"></div>
            </div>
            <form @submit.prevent="onSubmitCode">
                <input
                    id="codeInput"
                    autocomplete="off"
                    class="input--hidden"
                    inputmode="decimal"
                    pattern="[0-9]*"
                    type="text"
                    min="0"
                    maxlength="6"
                    ref="codeInput"
                    v-model="code"
                    @input="onMobileKeyboardPress"
                    @blur="onInputBlur"
                />
            </form>
            <div class="safe-numbers" :class="['active-' + currentNumber, { topmost: !videoPlaying }]" v-if="!token">
                <div class="safe-numbers__buttons">
                    <div class="safe-btn btn-1" v-for="n in numbers" :key="n" :class="'btn-' + n" @click="onSelect(n)"></div>
                </div>
            </div>
            <div class="safe-clear" @click="onClear()" v-show="!videoPlaying && !token && !agreeTerms"></div>
            <template v-if="!token">
                <div class="safe-video" v-if="isMobile">
                    <video class="is-mobile" v-show="videoPlaying" ref="video" playsinline>Your browser does not support the video.</video>
                </div>
                <div class="safe-video" v-else>
                    <video class="is-desktop" v-show="videoPlaying" ref="video" playsinline>Your browser does not support the video.</video>
                </div>
            </template>
            <template v-if="token && result">
                <div class="safe-video">
                    <img :src="require(`@/assets/results/${result.group}/mobile.png`)" alt="" v-if="isMobile" />
                    <img :src="require(`@/assets/results/${result.group}/desktop.png`)" alt="" v-else />
                </div>
            </template>
            <transition name="show">
                <div class="safe-result" v-if="result && videoPlaying">
                    <input v-if="result && result.share" ref="copyLinkInput" class="input--hidden" type="text" v-model="result.share.url" />
                    <div class="title" v-html="result.title"></div>
                    <div class="result">
                        <div class="result-1" v-if="result.values && result.values.bonus">
                            <div class="name">{{ result.values.bonus.name }}</div>
                            <div class="value">{{ result.values.bonus.value }}</div>
                            <div class="pic">
                                <img src="@/assets/safe/money.png" alt />
                            </div>
                        </div>
                        <div class="result-2" v-if="result.values && result.values.cash">
                            <div class="name">{{ result.values.cash.name }}</div>
                            <div class="value">{{ result.values.cash.value }}</div>
                            <div class="pic">
                                <img src="@/assets/safe/gold.png" alt />
                            </div>
                        </div>
                    </div>
                    <div class="share" v-if="!isFinish && result && result.share">
                        <div class="row">
                            <div class="label">Share</div>
                            <div class="links">
                                <ShareNetwork
                                    class="social"
                                    network="facebook"
                                    :url="result.share.url"
                                    :title="result.share.title"
                                    :description="result.share.message"
                                    :quote="result.share.title"
                                >
                                    <img src="@/assets/facebook.svg" alt="Facebook" />
                                </ShareNetwork>
                                <ShareNetwork
                                    class="social"
                                    network="twitter"
                                    :url="result.share.url"
                                    :title="result.share.title"
                                    :description="result.share.message"
                                    :quote="result.share.title"
                                >
                                    <img src="@/assets/twitter.svg" alt="Twitter" />
                                </ShareNetwork>
                                <a class="link" @click="copyLink">Copy link</a>
                            </div>
                        </div>
                        <div class="row" v-if="result.values && result.values.cash && result.cash">
                            <span class="redeem">Or tell login <b>{{ result.userName }}</b> to your local cashier to get your <b>{{result.values.cash.value}}</b> {{result.values.cash.name}}</span>
                        </div>
                    </div>
                    <div class="enroll" v-if="isFinish && result">
                        <div class="label">
                            Want to see how much you get?
                            <br />Enroll & claim
                            <span class="green-color">Your Cash First Rebate</span>
                        </div>
                        <a class="btn btn-white" :href="result.siteUrl">Enroll now</a>
                    </div>
                    <div class="finish" v-if="!isFinish" @click="isFinish = true"></div>
                </div>
            </transition>
            <transition name="show">
                <div
                    class="safe-popover popover popover-active topmost"
                    v-if="(!code.length || (code.length != count && isMobile)) && !submitted && !token && !codeInputFocused && !codeError"
                >
                    <div class="popover__container" @touchstart="focusAndOpenKeyboard">
                        <div class="popover__content">Enter the code</div>
                    </div>
                </div>
            </transition>
            <transition name="show">
                <div
                    class="safe-popover popover popover-green popover-active topmost"
                    v-if="code.length == count && !submitted && !token && !showTerms && !codeError"
                    @click="onSubmitCode"
                >
                    <div class="popover__container">
                        <div class="popover__content">
                            Show me
                            <br />the money
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="show">
                <div class="safe-popover popover popover-red popover-active topmost" v-if="codeError" @click="onClear">
                    <div class="popover__container">
                        <div class="popover__content">
                            Wrong
                            <br />code
                        </div>
                    </div>
                </div>
            </transition>
            <div class="safe-terms-overlay" v-if="code.length == count && !agreeTerms && !codeError" @click="onSubmitCode"></div>
            <modal class="safe-modal-terms" :isOpen="showTerms" @close="showTerms = false">
                <div slot="header">Terms & Conditions</div>
                <div class="safe-terms" slot="body">
                    <div class="body scrollbar">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lectus tellus, blandit vel malesuada nec, lobortis
                        sed quam. Sed ut libero quis turpis tempus laoreet. Suspendisse sed libero mauris. Class aptent taciti sociosqu ad
                        litora torquent per conubia nostra, per inceptos himenaeos. Nullam ornare tincidunt est. Fusce id hendrerit neque,
                        at posuere nunc. Fusce urna arcu, convallis faucibus ipsum nec, egestas tempus velit. Mauris tempus eu lectus ut
                        ornare. Quisque consectetur lectus malesuada euismod consequat. Cras et iaculis purus, et egestas nibh. Curabitur
                        non odio sed lorem sagittis tristique ut eget nisi. Quisque congue, neque id convallis bibendum, metus elit
                        tincidunt eros, in rutrum ipsum dolor non risus. Curabitur vel volutpat leo, nec ullamcorper leo. Etiam at nunc
                        augue. Proin lacinia aliquet nibh non lobortis. Integer rutrum commodo ornare. Etiam vel erat pellentesque eros
                        euismod tristique non vel enim. Integer vitae risus non velit cursus auctor. Aliquam erat volutpat. Fusce quis purus
                        lacinia, dapibus eros ut, rutrum nulla. Nulla fermentum in est eget dapibus. Pellentesque vel quam et urna
                        pellentesque vehicula. Morbi quis lacus felis. Mauris odio lorem, condimentum eget nulla non, maximus ornare mi.
                        Nunc facilisis, erat et accumsan vulputate, metus tortor pharetra nunc, eget gravida eros neque sit amet eros. Duis
                        sed turpis et mi viverra elementum. Mauris sit amet est commodo nisi gravida elementum. Vestibulum placerat
                        fringilla lacus eget pellentesque. Cras vitae neque ac nunc malesuada aliquet sit amet eu ex. Etiam mattis porttitor
                        augue, quis ultrices elit gravida eu. Donec rutrum purus libero, nec consequat arcu maximus in. Praesent rhoncus
                        libero ac urna porta elementum. Suspendisse ac eros vitae massa porta tincidunt. Quisque id volutpat erat. Morbi in
                        nulla vitae ex luctus ultrices. Quisque posuere nulla nulla, ac tincidunt nisl euismod ut. Proin congue, ipsum sit
                        amet interdum pharetra, mauris nibh interdum arcu, vel dignissim odio quam at urna. Morbi non felis vitae risus
                        maximus tempor ut eget diam. Mauris vitae congue tortor. Vivamus ut purus nisi. Vivamus augue nulla, imperdiet nec
                        neque non, vestibulum maximus quam. Vivamus mollis vehicula ante, id placerat lacus. Phasellus ligula magna, commodo
                        eget suscipit vitae, sodales id magna. Duis et purus tellus. Aenean sapien orci, scelerisque et massa et, iaculis
                        finibus nisl. Etiam viverra sapien vitae nisi gravida, et placerat nulla elementum. Nunc consequat pharetra
                        tincidunt. Proin arcu felis, congue nec orci nec, egestas dignissim elit. Suspendisse eget facilisis ipsum. In eget
                        nunc feugiat, imperdiet neque non, pretium nulla. Sed et suscipit tellus, at semper est. Integer faucibus maximus
                        ex, in ullamcorper lorem consectetur tincidunt. Aliquam vel lobortis nulla. Nulla sed posuere tellus, et pulvinar
                        libero. Sed vel neque erat. Nam at imperdiet felis. Nunc eu arcu sed lectus efficitur fringilla. Cras interdum nisi
                        sapien, at faucibus risus lacinia quis. Sed venenatis lectus at lectus rhoncus, eu finibus nulla porttitor.
                        Curabitur ipsum magna, faucibus vitae tellus non, dictum ullamcorper magna.
                    </div>
                    <div class="footer">You must agree the first</div>
                </div>
                <div class="actions" slot="footer">
                    <button class="btn btn-blue" @click="onAgreeTerms">Agree</button>
                    <button class="btn btn-grey" @click="onDisagreeTerms">Disagree</button>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
import Modal from './modal';
import isMobile from 'ismobilejs';
import { focusAndOpenKeyboard } from '../utils/mobile';
import { reveal, showPrize } from '../service';

export default {
    name: 'Safe',
    components: {
        Modal
    },
    props: ['token'],
    data() {
        return {
            code: '',
            currentNumber: 1,
            count: 6,
            numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
            showTerms: false,
            agreeTerms: false,
            result: null,
            isFinish: false,
            videoLoaded: false,
            videoPlaying: false,
            codeInputFocused: false,
            codeError: false,
            isLoaded: false,
            submitted: false
        };
    },
    computed: {
        isMobile() {
            return isMobile().any;
        }
    },
    async mounted() {
        if (this.token) {
            try {
                const result = await showPrize(this.token);
                this.videoLoaded = true;
                this.videoPlaying = true;
                this.agreeTerms = true;
                this.isLoaded = true;
                this.isFinish = true;
                this.result = this.mapSharedResult(result);
                this.$root.$emit('result', this.result);
                return;
            } catch (err) {
                this.$router.push('/');
            }
        }

        if (!this.result) {
            if (!this.isMobile) {
                this.subscribeToKeyEvents();
            }
            this.$root.$emit('result');
        }

        this.isLoaded = true;
    },
    methods: {
        onInputBlur() {
            this.codeInputFocused = false;
            if (this.isMobile && this.code.length == this.count) {
                setTimeout(() => this.onSubmitCode(), 300);
            }
        },
        focusAndOpenKeyboard() {
            if (!this.isMobile) return;
            focusAndOpenKeyboard('codeInput');
            this.codeInputFocused = true;
        },
        onMobileKeyboardPress(event) {
            if (event.inputType == 'insertText') {
                this.onNumberEntered(+event.data);
            }
        },
        subscribeToKeyEvents() {
            document.onkeydown = e => {
                e = e || window.event;
                if (e.keyCode >= 48 && e.keyCode <= 57) {
                    this.onSelect(e.keyCode - 48);
                } else if (e.keyCode >= 96 && e.keyCode <= 105) {
                    this.onSelect(e.keyCode - 96);
                } else if (e.keyCode == 8) {
                    this.onRemoveLastNumber();
                } else if (e.keyCode == 107 || e.keyCode == 13) {
                    if (this.code.length != this.count || this.codeError) return;

                    if (!this.showTerms && !this.agreeTerms) {
                        this.onSubmitCode();
                    } else if (!this.agreeTerms) {
                        this.onAgreeTerms();
                    }
                }
            };
        },
        async onSubmitCode() {
            if (this.code.length != this.count || this.codeError) return;
            this.submitted = true;
            this.$refs.codeInput.blur();

            try {
                const result = await reveal(this.code);
                this.loadVideo(result.group);
                this.result = this.mapResult(result);
                this.onShowTerms();
            } catch (err) {
                this.submitted = false;
                this.agreeTerms = false;
                this.codeError = true;
                console.log(err);
            }
        },
        onNumberEntered(num) {
            if (this.code.length == this.count) return;

            this.codeError = false;
            if (this.currentNumber != num) {
                this.currentNumber = +num;
            } else {
                this.currentNumber = +((num + 5) % 10);
                setTimeout(() => (this.currentNumber = +num), 500);
            }
        },
        loadVideo(group) {
            var videoRequest = new XMLHttpRequest();
            videoRequest.onload = () => {
                this.$refs.video.src = URL.createObjectURL(videoRequest.response);
                this.videoLoaded = true;
                this.playVideo();
            };
            videoRequest.open(
                'GET',
                this.isMobile ? require(`@/assets/results/${group}/mobile.mp4`) : require(`@/assets/results/${group}/desktop.webm`)
            );
            videoRequest.responseType = 'blob';
            videoRequest.send();
        },
        playVideo() {
            if (this.agreeTerms && this.videoLoaded) {
                this.videoPlaying = true;
                this.$refs.video.play();
            }
        },
        onSelect(num) {
            this.onNumberEntered(+num);
            if (this.code.length < this.count) this.code += +num;
        },
        onRemoveLastNumber() {
            if (!this.code.length) return;
            this.submitted = false;
            this.codeError = false;
            this.code = this.code.slice(0, -1);
        },
        onClear() {
            this.codeError = false;
            this.submitted = false;
            this.code = '';
            this.focusAndOpenKeyboard('codeInput');
        },
        classCode(num) {
            const symbol = this.code.substring(num - 1, num);
            const prevSymbol = this.code.substring(num - 2, num);
            return symbol ? 'code-' + symbol : prevSymbol ? 'code-select' : 'code-empty';
        },
        onShowTerms() {
            this.showTerms = true;
        },
        onAgreeTerms() {
            this.agreeTerms = true;
            this.showTerms = false;

            window.history.replaceState('', '', `/${this.result.token}`);
            this.$root.$emit('result', this.result);
            this.playVideo();
        },
        onDisagreeTerms() {
            this.showTerms = false;
            this.agreeTerms = false;
            this.onClear();
        },
        mapResult(result) {
            return {
                title: `<h2>Congratulations, ${result.firstName}!</h2><div>Pick up your rebate at «Welcome Travel»</div>`,
                values: {
                    bonus: { name: 'Bonus Dollars', value: '$' + result.bonus },
                    cash: { name: 'Cash Rebate', value: '$' + result.cash }
                },
                ...result
            };
        },
        mapSharedResult(sharedResult) {
            let result = this.mapResult(sharedResult);
            result.title = `<div>${result.firstName} recieved this</div><h2>Cash First Rebate</h2>`;
            return result;
        },
        copyLink() {
            var copyLinkInput = this.$refs.copyLinkInput;
            copyLinkInput.select();
            copyLinkInput.setSelectionRange(0, 99999);
            document.execCommand('copy');
        }
    }
};
</script>

<style lang="scss" scoped>
.topmost {
    z-index: 10 !important;
}

.popover-red {
    & .popover__container:before {
        background: #f46a6a;
    }
    & .popover__content {
        background: #f46a6a;
        color: #ffffff;
    }
}

.safe {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: $container;
    max-width: 100%;
    height: $container/(16/9);
    background: linear-gradient(to bottom, #dcdedf 0%, #f6f6f6 100%);
    margin: $gap auto;
    overflow: hidden;

    &.safe-result-showing {
        background: white;
    }

    .safe-container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        height: 100%;
    }

    .safe-img {
        position: relative;
        display: block;
        width: $container;
        height: $container/(16/9);
        background: url('~@/assets/safe/img.png') center bottom no-repeat;
    }

    .safe-display {
        position: absolute;
        bottom: 361px;
        left: 50%;
        display: flex;
        transform: translateX(-50%);
        z-index: 0;

        .safe-code {
            display: block;
            flex: 0 0 auto;
            width: 19px;
            height: 32px;
            background: url('~@/assets/safe/display.png') 0 0 no-repeat;
            background-position-x: 19px;

            + .safe-code {
                margin-left: 10px;
            }

            &.code-1 {
                background-position-x: 0;
            }
            &.code-2 {
                background-position-x: -19px;
            }
            &.code-3 {
                background-position-x: -38px;
            }
            &.code-4 {
                background-position-x: -57px;
            }
            &.code-5 {
                background-position-x: -76px;
            }
            &.code-6 {
                background-position-x: -95px;
            }
            &.code-7 {
                background-position-x: -114px;
            }
            &.code-8 {
                background-position-x: -133px;
            }
            &.code-9 {
                background-position-x: -152px;
            }
            &.code-0 {
                background-position-x: -171px;
            }
        }

        &.display-active {
            .safe-code {
                &.code-select {
                    background-position-x: -209px;
                    animation: display-select 0.5s infinite;
                }
            }
        }

        &:not(.display-active) {
            .safe-code {
                background-position-x: -190px;
                animation: display-tick 1.5s infinite;

                &:nth-child(2) {
                    animation-delay: 0.25s;
                }

                &:nth-child(3) {
                    animation-delay: 0.5s;
                }

                &:nth-child(4) {
                    animation-delay: 0.75s;
                }

                &:nth-child(5) {
                    animation-delay: 1s;
                }

                &:nth-child(6) {
                    animation-delay: 1.25s;
                }
            }
        }
    }

    .input--hidden {
        opacity: 0;
        position: absolute;
        bottom: 240px;
        left: 50%;
        margin-left: -93px;
        font-size: 2rem;
        display: inline-block;
        width: 186px;
        text-shadow: 0 0 0 gray;
        color: transparent !important;
        transform: scale(0);
    }

    .safe-clear {
        position: absolute;
        bottom: 300px;
        left: 50%;
        width: 40px;
        height: 40px;
        margin-left: 85px;
        border-radius: 100%;
        background: url('~@/assets/safe/clear.png') 0 0 no-repeat;
        background-size: cover;
        cursor: pointer;
        z-index: 10;
    }

    .safe-numbers {
        position: absolute;
        width: 186px;
        height: 186px;
        bottom: 133px;
        left: 50%;
        margin-left: -93px;
        background: url('~@/assets/safe/numbers.png') 0 0 no-repeat;
        background-size: cover;
        transition: transform 0.3s linear;
        transform-origin: center;

        .safe-numbers__buttons {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            .safe-btn {
                position: absolute;
                width: 20%;
                height: 20%;
                left: 50%;
                top: 50%;
                margin-left: -10%;
                margin-top: -10%;
                border-radius: 100%;
                cursor: pointer;

                &.btn-1 {
                    transform: translate(0, -200%);
                }

                &.btn-2 {
                    transform: translate(110%, -165%) rotate(35deg);
                }

                &.btn-3 {
                    transform: translate(180%, -70%) rotate(70deg);
                }

                &.btn-4 {
                    transform: translate(185%, 45%) rotate(105deg);
                }

                &.btn-5 {
                    transform: translate(115%, 140%) rotate(145deg);
                }

                &.btn-6 {
                    transform: translate(0, 180%);
                }

                &.btn-7 {
                    transform: translate(-115%, 140%) rotate(215deg);
                }

                &.btn-8 {
                    transform: translate(-185%, 45%) rotate(250deg);
                }

                &.btn-9 {
                    transform: translate(-180%, -70%) rotate(285deg);
                }

                &.btn-0 {
                    transform: translate(-110%, -165%) rotate(320deg);
                }
            }
        }

        &.active-1 {
            transform: rotate(0);
        }
        &.active-2 {
            transform: rotate(-36deg);
        }
        &.active-3 {
            transform: rotate(-72deg);
        }
        &.active-4 {
            transform: rotate(-108deg);
        }
        &.active-5 {
            transform: rotate(-144deg);
        }
        &.active-6 {
            transform: rotate(-180deg);
        }
        &.active-7 {
            transform: rotate(-216deg);
        }
        &.active-8 {
            transform: rotate(-252deg);
        }
        &.active-9 {
            transform: rotate(-288deg);
        }
        &.active-0 {
            transform: rotate(-324deg);
        }
    }

    .safe-popover {
        left: 50%;
        bottom: 50%;
        margin-left: 170px;
        transform: translateY(50%);
        cursor: pointer;

        &.show-enter,
        &.show-leave-active {
            opacity: 0;
            transform: translateY(100%);
        }
    }

    .safe-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        video,
        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .safe-terms-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        cursor: pointer;
    }

    .safe-modal-terms::v-deep {
        position: absolute;

        .modal-container {
            max-height: 80%;
        }

        .modal-body {
            display: flex;
            padding: 0;
        }

        .modal-footer {
            .actions {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: -$gap/2;
                margin-right: -$gap/2;

                .btn {
                    margin: 0 $gap/2;
                }
            }
        }
    }

    .safe-terms {
        display: flex;
        flex-direction: column;
        max-height: 100%;
        overflow: hidden;

        .body {
            flex: 1 1 auto;
            overflow: auto;
            margin: 0 $gap * 2;
        }

        .footer {
            flex: 0 0 auto;
            padding: $gap;
            margin-top: $gap;
            background: $green;
            text-align: center;
        }
    }

    .safe-result {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        transition: all 0.3s linear;
        transition-delay: 1s;

        > .title {
            display: none;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 14rem;
            text-align: center;
            flex: 0 0 auto;
            font-size: 1.6rem;
            font-weight: bold;
            color: $white;
            padding: $gap;
            z-index: 1;

            ::v-deep {
                h2 {
                    font-size: 3.6rem;
                    margin: 0;
                }

                h3 {
                    font-size: 3rem;
                    margin: 0;
                }

                h4 {
                    font-size: 2.4rem;
                    margin: 0;
                }

                p {
                    position: absolute;
                    bottom: 16rem;
                    left: 0;
                    right: 0;
                    margin: 0;
                }
            }
        }

        > .result {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex: 1 1 auto;
            z-index: 1;
            transition: all 0.3s linear;
            margin-bottom: 10rem;

            > div {
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                padding: 0 $gap * 2;
                color: $white;
                width: 30%;

                .name {
                    font-size: 2rem;
                    text-align: center;
                }

                .value {
                    font-size: 3rem;
                    font-weight: bold;
                    text-align: center;
                }

                .pic {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 16rem;
                    height: 16rem;
                    margin-top: $gap * 2;

                    &:before {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background: url('~@/assets/safe/star.svg') 0 0 no-repeat;
                        background-size: cover;
                        animation: star 10s linear infinite;
                    }

                    img {
                        position: relative;
                        display: block;
                        width: 70%;
                        max-width: 100%;
                        max-height: 100%;
                        animation: money 3s linear infinite;
                    }
                }

                &:last-child {
                    .pic img {
                        animation-delay: 0.3s;
                    }
                }
            }
        }

        > .share {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            display: flex;
            flex: 0 0 auto;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: $light;
            color: $black;
            padding: $gap;
            font-size: 2.4rem;
            font-weight: bold;
            z-index: 3;
            transition: all 0.3s linear;

            .row {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .redeem {
                text-align: center;
                font-weight:initial;
                font-size: 14px;
                color: #828282;
            }

            .label,
            .links {
                margin: $gap 0;
            }

            .links {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .label,
            .social,
            .link {
                margin-left: $gap;
                margin-right: $gap;
                cursor: pointer;
            }
        }

        > .enroll {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            display: flex;
            flex: 0 0 auto;
            justify-content: center;
            align-items: center;
            color: $white;
            padding: $gap;
            font-size: 2.1rem;
            font-weight: bold;
            z-index: 3;
            transition: all 0.3s linear;

            .label {
                text-align: right;
            }

            .label,
            .btn {
                margin: $gap;
            }
        }

        > .finish {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
            cursor: pointer;
        }

        &.show-enter,
        &.show-leave-active {
            opacity: 0;
        }

        &.show-enter > .result,
        &.show-leave-active > .result {
            transform: scale(0);
        }

        &.show-enter > .share,
        &.show-leave-active > .share {
            transform: translateY(100%);
        }
    }

    &.safe-complete {
        .safe-display {
            .safe-code {
                animation: display-complete 0.5s infinite;
            }
        }
    }
}

@keyframes display-tick {
    0% {
        opacity: 1;
    }
    5% {
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    100% {
        opacity: 1;
    }
}

@keyframes display-select {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes display-complete {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes star {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes money {
    0% {
        transform: scale(1);
    }
    5% {
        transform: scale(1.2);
    }
    10% {
        transform: scale(0.95);
    }
    15% {
        transform: scale(1.05);
    }
    20% {
        transform: scale(1);
    }
    100% {
        transform: scale(1);
    }
}

@media (max-width: $mobile) {
    .safe {
        .safe-modal-terms::v-deep {
            position: fixed;
        }
    }

    .safe-popover {
        transform: translateX(-50%) rotate(180deg) !important;
        bottom: 240px !important;
    }
    .popover__content {
        transform: rotate(180deg);
    }
}

@media (max-width: $mobile) and (orientation: portrait) {
    .safe {
        background: transparent;
        min-height: 60vh;

        .safe-popover {
            margin: 0;

            &.show-enter,
            &.show-leave-active {
                opacity: 0;
                transform: translate(-50%, 100%);
            }
        }

        &.safe-video-ready {
            .safe-video {
                position: fixed;
            }
        }

        .safe-result {
            position: fixed;

            > .title {
                display: flex;
            }

            > .result {
                justify-content: space-between;
                align-items: flex-start;

                > div {
                    width: 50%;

                    .pic {
                        width: 12rem;
                        height: 12rem;
                        order: -1;
                    }
                }
            }

            > .share,
            > .enroll {
                flex-direction: column;

                .label {
                    text-align: center;
                }
            }
        }
    }
}

@media (min-width: $mobile+1) {
    .is-mobile {
        display: none !important;
    }
}

@media (max-width: $mobile) and (orientation: landscape) {
    .is-mobile {
        display: none !important;
    }

    .is-desktop {
        display: flex !important;
    }
}

@media (max-width: 320px) {
    .safe {
        height: 400px;

        .safe-img,
        .safe-display,
        .safe-clear,
        .safe-numbers,
        .safe-popover {
            zoom: 0.8;
        }
    }
}
</style>
